import React, { useEffect, useState } from 'react';
import { Button, Card, Divider, Form } from '@douyinfe/semi-ui';
import Title from '@douyinfe/semi-ui/lib/es/typography/title';
import Text from '@douyinfe/semi-ui/lib/es/typography/text';
import { Link, useNavigate } from 'react-router-dom';
import { API, getLogo, showError, showInfo, showSuccess } from '../helpers';
import Turnstile from 'react-turnstile';

const RegisterForm = () => {
  const [inputs, setInputs] = useState({
    username: '',
    password: '',
    password2: '',
    email: '',
    verification_code: ''
  });
  const { username, password, password2 } = inputs;
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [turnstileEnabled, setTurnstileEnabled] = useState(false);
  const [turnstileSiteKey, setTurnstileSiteKey] = useState('');
  const [turnstileToken, setTurnstileToken] = useState('');
  const [loading, setLoading] = useState(false);
  const logo = getLogo();
  let affCode = new URLSearchParams(window.location.search).get('aff');
  if (affCode) {
    localStorage.setItem('aff', affCode);
  }

  useEffect(() => {
    let status = localStorage.getItem('status');
    if (status) {
      status = JSON.parse(status);
      setShowEmailVerification(status.email_verification);
      if (status.turnstile_check) {
        setTurnstileEnabled(true);
        setTurnstileSiteKey(status.turnstile_site_key);
      }
    }
  });

  let navigate = useNavigate();

  function handleChange(name, value) {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  }

  async function handleSubmit(e) {
    if (password.length < 8) {
      showInfo('密码长度不得小于 8 位！');
      return;
    }
    if (password !== password2) {
      showInfo('两次输入的密码不一致');
      return;
    }
    if (username && password) {
      if (turnstileEnabled && turnstileToken === '') {
        showInfo('请稍后几秒重试，Turnstile 正在检查用户环境！');
        return;
      }
      setLoading(true);
      if (!affCode) {
        affCode = localStorage.getItem('aff');
      }
      inputs.aff_code = affCode;
      const res = await API.post(
        `/api/user/register?turnstile=${turnstileToken}`,
        inputs
      );
      const { success, message } = res.data;
      if (success) {
        navigate('/login');
        showSuccess('注册成功！');
      } else {
        showError(message);
      }
      setLoading(false);
    }
  }

  const sendVerificationCode = async () => {
    if (inputs.email === '') return;
    if (turnstileEnabled && turnstileToken === '') {
      showInfo('请稍后几秒重试，Turnstile 正在检查用户环境！');
      return;
    }
    setLoading(true);
    const res = await API.get(
      `/api/verification?email=${inputs.email}&turnstile=${turnstileToken}`
    );
    const { success, message } = res.data;
    if (success) {
      showSuccess('验证码发送成功，请检查你的邮箱！');
    } else {
      showError(message);
    }
    setLoading(false);
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f7fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '480px' }}>
        {/* Logo 和品牌名称 */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '32px'
        }}>
          <img 
            src={logo} 
            alt="Logo" 
            style={{ 
              width: '64px', 
              height: '64px',
              marginBottom: '16px'
            }} 
          />
          <Title heading={2} style={{ 
            margin: 0, 
            color: '#303133',
            fontWeight: '600'
          }}>
            用户注册
          </Title>
          <Text style={{ 
            color: '#909399', 
            marginTop: '8px',
            fontSize: '14px'
          }}>
            创建新账户以开始使用我们的服务
          </Text>
        </div>

        <Card 
          style={{ 
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            border: '1px solid #e4e7ed'
          }}
        >
          <div style={{ padding: '32px' }}>
            <Form>
              <Form.Input
                field={'username'}
                label={'用户名'}
                placeholder="请输入用户名（最长12位）"
                name="username"
                size="large"
                style={{ marginBottom: '20px' }}
                onChange={(value) => handleChange('username', value)}
              />
              <Form.Input
                field={'password'}
                label={'密码'}
                placeholder="请输入密码（8-20位）"
                name="password"
                type="password"
                size="large"
                style={{ marginBottom: '20px' }}
                onChange={(value) => handleChange('password', value)}
              />
              <Form.Input
                field={'password2'}
                label={'确认密码'}
                placeholder="请再次输入密码"
                name="password2"
                type="password"
                size="large"
                style={{ marginBottom: '20px' }}
                onChange={(value) => handleChange('password2', value)}
              />
              {showEmailVerification && (
                <>
                  <Form.Input
                    field={'email'}
                    label={'邮箱'}
                    placeholder="请输入邮箱地址"
                    name="email"
                    type="email"
                    size="large"
                    style={{ marginBottom: '20px' }}
                    onChange={(value) => handleChange('email', value)}
                    suffix={
                      <Button 
                        onClick={sendVerificationCode} 
                        disabled={loading}
                        size="small"
                        style={{ 
                          marginRight: '8px',
                          background: '#67c23a',
                          border: 'none',
                          borderRadius: '4px'
                        }}
                      >
                        获取验证码
                      </Button>
                    }
                  />
                  <Form.Input
                    field={'verification_code'}
                    label={'验证码'}
                    placeholder="请输入验证码"
                    name="verification_code"
                    size="large"
                    style={{ marginBottom: '20px' }}
                    onChange={(value) => handleChange('verification_code', value)}
                  />
                </>
              )}
              {turnstileEnabled && (
                <div style={{ marginBottom: '20px' }}>
                  <Turnstile
                    sitekey={turnstileSiteKey}
                    onVerify={(token) => {
                      setTurnstileToken(token);
                    }}
                  />
                </div>
              )}
              <Button 
                theme="solid" 
                style={{ 
                  width: '100%',
                  background: '#67c23a',
                  border: 'none',
                  height: '40px',
                  fontSize: '14px',
                  fontWeight: '500',
                  borderRadius: '4px'
                }} 
                type={'primary'} 
                size="large"
                loading={loading}
                onClick={handleSubmit}>
                注册
              </Button>
            </Form>

            <Divider margin="24px" />
            <div style={{ textAlign: 'center', fontSize: '14px' }}>
              <Text style={{ color: '#909399' }}>
                已有账户？
                <Link to="/login" style={{ 
                  color: '#409eff',
                  textDecoration: 'none',
                  marginLeft: '8px',
                  fontWeight: '500'
                }}>
                  立即登录
                </Link>
              </Text>
            </div>
          </div>
        </Card>

        {/* 底部版权信息 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '32px',
          color: '#c0c4cc',
          fontSize: '12px'
        }}>
          © 2026 AI API Platform. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
